export default __webpack_public_path__ + "static/media/IconChevronDown.54f19863.svg";